<template>
  <div class="index-page container">
    <n-card>
      <n-divide class="table-tools">
        <div></div>
        <n-button @click="$router.push({name: 'users.create'})">Добавить пользователя</n-button>
      </n-divide>
  
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #content="{item}">
          <div v-html="item.content" />
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'users.edit', params: { id: item.id, }})" />
        </template>
      </n-table>

    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'username', title: 'Логин', },
      { name: 'fullName', title: 'Имя', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.app.users.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
  }
</style>
